// Small UI helpers for the staff portal (no framework).
export const TZ = 'America/Los_Angeles';

export function esc(v) {
  return String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}
export const money = (cents) => ((cents ?? 0) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
export const dateTime = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { timeZone: TZ, weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '');
export const dateOnly = (iso) => (iso ? new Date(iso).toLocaleDateString('en-US', { timeZone: TZ, month: 'short', day: 'numeric', year: 'numeric' }) : '');
export const monthLabel = (iso) => new Date(iso).toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', year: 'numeric' });

export function toast(message, kind = 'ok') {
  const el = document.createElement('div');
  el.className = `toast${kind === 'error' ? ' error' : ''}`;
  el.setAttribute('role', kind === 'error' ? 'alert' : 'status');
  el.textContent = message;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), kind === 'error' ? 7000 : 3500);
}

// Opens a <dialog> with the given inner form HTML. Resolves with FormData on submit, or null on cancel.
// `validate(formData)` may return an error message to keep the dialog open.
export function dialog(html, validate) {
  return new Promise((resolve) => {
    const d = document.createElement('dialog');
    d.innerHTML = `<form method="dialog" novalidate>${html}</form>`;
    document.body.appendChild(d);
    const form = d.querySelector('form');
    let result = null;
    form.addEventListener('submit', (e) => {
      if (e.submitter?.value === 'cancel') return;
      const err = form.querySelector('[data-error]');
      const missing = [...form.querySelectorAll('[required]')].find((i) => !i.value.trim());
      if (missing) { e.preventDefault(); if (err) err.innerHTML = '<p class="notice error">Please fill in the required fields.</p>'; missing.focus(); return; }
      const data = new FormData(form);
      const problem = validate?.(data);
      if (problem) { e.preventDefault(); if (err) err.innerHTML = `<p class="notice error">${esc(problem)}</p>`; return; }
      result = data;
    });
    d.addEventListener('close', () => { d.remove(); resolve(result); });
    d.showModal();
  });
}

export const statusBadge = (s) => {
  const map = {
    held: ['Held', 'dashed'], deposit_paid: ['Confirmed', 'gold'], paid_in_full: ['Paid in full', 'solid'],
    cancelled: ['Cancelled', 'red'], expired: ['Checkout expired', 'dashed'],
  };
  const [label, cls] = map[s] || [s, ''];
  return `<span class="badge ${cls}">${esc(label)}</span>`;
};

export function guard(fn) {
  return async (...args) => {
    try { return await fn(...args); } catch (e) { toast(e.message || 'Something went wrong', 'error'); return undefined; }
  };
}
